import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { CardHeaderTitleSubtitleComponent } from '../../ui/card-header-title-subtitle/card-header-title-subtitle.component';
import { SharedService } from '../../services/shared.service';
import { Router } from '@angular/router';
import { RoutePaths } from '../../../../core/constants/route-paths';
import { DataLayerService } from '../../../../core/services/data-layer.service';

@Component({
  selector: 'app-auth-verification-handler',
  standalone: true,
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    CardHeaderTitleSubtitleComponent,
  ],
  providers: [SharedService],
  templateUrl: './auth-verification-handler.component.html',
  styleUrl: './auth-verification-handler.component.scss',
})
export class AuthVerificationHandlerComponent {
  @Input() view: string = '';
  private _process: AuthVerifMapKeys = 'error';
  @Input()
  set process(value: AuthVerifMapKeys | null | undefined) {
    this._process = value ?? 'error';
  }
  get process(): AuthVerifMapKeys {
    return this._process;
  }
  @Output() goBackClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() btnContClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
  title!: string;
  subtitle!: string;
  icon!: string;
  showContinueBtn: boolean = false;
  screenName: string = `${this.view}-status`;

  constructor(private readonly _router: Router,
      private readonly _dataLayerService: DataLayerService,) {}

  ngOnInit(): void {
    this._dataLayerService.pushEventPageView(this.screenName);
    const titlesMap: Record<AuthVerifMapKeys, AuthVerifMapEntry> = {
      passSuccess: {
        title: 'title-pass-success',
        subtitle: 'subtitle-pass-success',
        icon: 'icon-pulgar-arriba',
        contBtn: false,
      },

      tokenPassSuccess: {
        title: 'title-token-pass-success',
        subtitle: 'subtitle-token-pass-success',
        icon: 'icon-pulgar-arriba',
        contBtn: false,
      },
      tokenCaducado: {
        title: 'title-pass-caducado',
        subtitle: 'subtitle-pass-caducado',
        icon: 'icon-circulo-error',
        contBtn: false,
      },
      tokenUsed: {
        title: 'title-pass-used',
        subtitle: 'subtitle-pass-used',
        icon: 'icon-pulgar-arriba',
        contBtn: false,
      },
      tokenPassError: {
        title: 'title-pass-error',
        subtitle: 'subtitle-pass-error',
        icon: 'icon-circulo-error',
        contBtn: false,
      },

      registerPending: {
        title: 'title-reg-pending',
        subtitle: 'subtitle-reg-pending',
        icon: 'icon-pulgar-arriba',
        contBtn: true,
      },
      registerRejected: {
        title: 'title-reg-rejected',
        subtitle: 'subtitle-reg-rejected',
        icon: 'icon-circulo-error',
        contBtn: true,
      },
      registerActive: {
        title: 'title-reg-active',
        subtitle: 'subtitle-reg-active',
        icon: 'icon-pulgar-arriba',
        contBtn: true,
      },
      registerSuccess: {
        title: 'title-reg-success',
        subtitle: 'subtitle-reg-success',
        icon: 'icon-pulgar-arriba',
        contBtn: true,
      },
      registerInt: {
        title: 'title-reg-user-int',
        subtitle: 'subtitle-reg-user-int',
        icon: 'icon-circulo-error',
        contBtn: false,
      },
      registerError: {
        title: 'title-reg-error',
        subtitle: 'subtitle-reg-error',
        icon: 'icon-circulo-error',
        contBtn: false,
      },

      error: {
        title: 'title-reg-success',
        subtitle: 'subtitle-reg-success',
        icon: 'icon-circulo-error',
        contBtn: false,
      },
    };

    const { title, subtitle, icon, contBtn } =
      titlesMap[this.process as AuthVerifMapKeys];
    this.title = title;
    this.subtitle = subtitle;
    this.icon = icon;
    this.showContinueBtn = contBtn;
  }

  _btnBack(): void {
    this._dataLayerService.pushEventClickButton(this.screenName, 'go_back', `auth-verification.btn-back`);
    this.goBackClicked.emit(true);
  }

  _btnCont(): void {
    this._dataLayerService.pushEventClickButton(this.screenName, 'continue', `auth-verification.btn-continue`);
    this.btnContClicked.emit(true);
  }

  async _goSendEmail(): Promise<void> {
    this._dataLayerService.pushEventClickLink(this.screenName, 'send_email', `auth-verification.send-email`);
    await this._router.navigate([`${RoutePaths.changePassword}`]);
  }
}
